<template>
  <header 
    class="l-header" 
    :class="{
      'is-menu-open': isMenuOpen,
      'is-white': isWhite && !isSwitchedToDefault
    }">
    <h1 class="l-header__heading">
      <router-link to="/" exact class="l-header__logo">
        <span class="l-header__title">Setouchi Cominca Stays</span>
      </router-link>
    </h1>
    <div class="l-header__trigger" @click.prevent="onClickTrigger">Destination</div>
    <router-link :to="{name: 'about'}" class="l-header__about">About Setouchi Cominca Stays</router-link>
  </header>
</template>

<script>
  /**
   * Modules
   */
  import { mapGetters, mapActions, mapMutations } from 'vuex'

  /**
   * Share Partial
   */

  export default {
    name: 'global-header',
    components: {
    },
    data () {
      return {
        isSwitchedToDefault: false
      }
    },
    watch: {
      '$window.scrollY'() {
        this.isSwitchedToDefault = this.$window.scrollY > this.$window.height
      },
      isMenuOpen(value) {
        if(value) {
          document.querySelector('html').classList.add('hidden')  
        } else {
          document.querySelector('html').classList.remove('hidden')  
        }
        
      }
    },
    computed: {
      isMobile() {
        return this.$window.viewport === 'mobile'
      },
      isTop() {
        return this.$route.path === '/'
      },
      isPcTop() {
        return this.isTop && this.$window.viewport === 'desktop'
      },
      isWhite() {
        // top, sp about, sp destination ではコンテンツの色を白くしておく
        return this.$route.path === '/' || (
          this.$route.name === 'about' && this.isMobile
        ) || (
          this.$route.name === 'destination' && this.isMobile
        )
      },
      ...mapGetters({
        'getInfo': 'route/getInfo',
        'isMenuOpen': 'menu/isOpen',
      })
    },
    created() {
    },
    mounted() {
    },
    methods: {
      onClickTrigger() {
        this.toggleMenu()
      },
      ...mapMutations({
        'toggleMenu': 'menu/TOGGLE',
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/global-header.vue